import { z } from "zod";
import { ReportAction } from "../enum.js";

export const resolveReportSchema = z
	.object({
		action: z.enum(ReportAction),
		message: z.string().max(500, { message: "Message must be at most 500 characters" }).optional(),
	})
	.strict();

export type ResolveReportPayload = z.infer<typeof resolveReportSchema>;
